import React, { useMemo, useState } from 'react';
import './index.scss';
import { Drawer, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { ApiDocumentContext } from '@/contexts/ApiDocumentContext';
import ButtonComponent from '@/components/Button';
import { uniqueId } from 'lodash';
// import SenderDocs from './Sender';
import SmsMKT from './SmsMKT';
import SmsOTP from './SmsOTP';
import ErrorTable from './ErrorTable';

function Document() {
  const { t } = useTranslation();

  const onChange = (key) => {
    console.log(key);
  };

  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState();
  const [resData, setResData] = useState({});
  const onClose = () => {
    setOpenDrawer(false);
    setTimeout(() => {
      setDrawerTitle();
      setResData({});
    }, 50);
  };

  const items = [
    // {
    //   key: '#sender',
    //   label: t('api_page.documents.menu.sender_api'),
    //   children: <SenderDocs />,
    // },
    {
      key: '#sms-mkt',
      label: t('api_page.documents.menu.sms_mkt_api'),
      children: <SmsMKT />,
    },
    {
      key: '#sms-otp',
      label: t('api_page.documents.menu.sms_otp_api'),
      children: <SmsOTP />,
    },
    {
      key: '#error-otp',
      label: t('api_page.documents.menu.sms_error_table'),
      children: <ErrorTable />,
    },
  ];

  const customRenderTabBar = (props, DefaultTabBar) => (
    <DefaultTabBar className="tab-bar-custom" {...props} />
  );

  const contexValue = useMemo(
    () => ({
      openDrawer,
      setOpenDrawer,
      setDrawerTitle,
      setResData,
    }),
    [openDrawer],
  );

  const renderResponseNestedObject = (schema) => (
    <div className="response-object --nested">
      <div className="type">object</div>
      {Object.keys(schema).length > 0 &&
        Object.keys(schema).map((key) => (
          <div className="property" key={uniqueId()}>
            <div className="property__name">{key}</div>
            <div className="property__type">{schema[`${key}`]}</div>
          </div>
        ))}
    </div>
  );

  return (
    <ApiDocumentContext.Provider value={contexValue}>
      <div className="api-document" id="api-document">
        <Tabs
          size="large"
          tabPosition="left"
          defaultActiveKey="#sender"
          items={items}
          onChange={onChange}
          destroyInactiveTabPane
          renderTabBar={customRenderTabBar}
          tabBarGutter="2px"
        />
        <Drawer
          className="drawer-custom"
          title={drawerTitle}
          placement="right"
          onClose={onClose}
          open={openDrawer}
          getContainer={() => document.getElementById('api-document')}
          destroyOnClose
        >
          <div className="title">
            {t('api_page.documents.drawer.response_body')}
          </div>
          <div className="detail">
            <div className="response-object">
              <div className="type">{resData.type}</div>
              {Object.keys(resData).length > 0 &&
                Object.keys(resData.properties).length > 0 &&
                Object.keys(resData.properties).map((key) => {
                  const { properties } = resData;
                  const property = properties[`${key}`];
                  const hasNested =
                    Object.keys(property).length > 0 &&
                    Object.prototype.hasOwnProperty.call(property, 'schema');

                  return (
                    <div
                      key={uniqueId()}
                      className={`property-wrap${
                        hasNested ? ' --has-nested' : ''
                      }`}
                    >
                      <div
                        className={`property${
                          hasNested ? ' --has-nested' : ''
                        }`}
                      >
                        <div className="property__name">{key}</div>
                        <div className="property__type">
                          {properties[`${key}`].type}
                        </div>
                      </div>
                      {hasNested &&
                        renderResponseNestedObject(properties[`${key}`].schema)}
                    </div>
                  );
                })}
            </div>
          </div>
          <ButtonComponent onClick={onClose}>
            {t('api_page.documents.drawer.btn_close')}
          </ButtonComponent>
        </Drawer>
      </div>
    </ApiDocumentContext.Provider>
  );
}

export default Document;
